export const formatRecord = record => ({
  ...record,
  payExpire: formatDate(new Date(record.ctime).toLocaleDateString()),
  money: (record.amtFen / 100).toFixed(2) + "元",
  invoicedStatus: record.invoicedStatus === "INVOICED" ? "是" : "否"
});

export const formatInvoice = invoice => ({
  ...invoice,
  createTime: formatDate(new Date(invoice.createTime).toLocaleDateString()),
  amount: (invoice.amount / 100).toFixed(2) + "元",
  status: formatInvoiceStatus(invoice.status),
  invoiceWay: formatInvoiceWay(invoice.invoiceWay)
});

export const formatMessage = (record, key) => ({
  ...record,
  ctime: new Date(record.ctime * 1000).toLocaleString(),
  key: key,
  status: formateMessageStatus(record.status)
});

export const formateMessageStatus = status => {
  switch (status) {
    case "SUCCESS":
      return "审核成功";
    case "FAIL":
      return "审核失败";
    default:
      return "审核中";
  }
};

export function convertInvoice(type) {
  let obj = {};
  switch (type) {
    case "ENTERPRISE_ELECTRONIC_INVOICE":
      obj = { invoiceWay: "E_INVOICE", invoiceType: "COMMON" };
      break;
    case "ENTERPRISE_PAPER_INVOICE":
      obj = { invoiceWay: "P_INVOICE", invoiceType: "COMMON" };
      break;
    case "ENTERPRISE_SPECIAL_PRPER_INVOICE":
      obj = { invoiceWay: "P_INVOICE", invoiceType: "PROFESSIONAL" };
      break;
    default:
      obj = { invoiceWay: "", invoiceType: "" };
  }

  return obj;
}
export function b64toBlob(dataURI) {
  // convert base64/URLEncoded data component to raw binary data held in a string
  var byteString;
  if (dataURI.split(",")[0].indexOf("base64") >= 0)
    byteString = atob(dataURI.split(",")[1]);
  else byteString = unescape(dataURI.split(",")[1]);
  // separate out the mime component
  var mimeString = dataURI
    .split(",")[0]
    .split(":")[1]
    .split(";")[0];
  // write the bytes of the string to a typed array
  var ia = new Uint8Array(byteString.length);
  for (var i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }
  return new Blob([ia], { type: mimeString });
}

// TODO 重构这个函数
export const formatDate = date => {
  let formatDate = "";
  let reg = /^(\d{4})\/(\d{1,2})\/(\d{1,2})$/;
  formatDate = date.replace(reg, ($0, $1, $2, $3) => {
    return $1 + "年" + $2 + "月" + $3 + "日";
  });
  return formatDate;
};

export const timestamp2DateStr = timestamp => {
  return formatDate(new Date(timestamp).toLocaleDateString());
};

export const formatLineDate = date => {
  return date.replace(/\//g, "-") + " 00:00:00";
};

export const formatInvoiceWay = way => {
  switch (way) {
    case "P_INVOICE":
      return "纸质发票";
    case "E_INVOICE":
      return "电子发票";
    default:
      return null;
  }
};

export const formatInvoiceStatus = status => {
  switch (status) {
    case "TOBEMAILED":
      return "待审核";
    case "REJECTED":
      return "被拒绝";
    default:
      return "已邮寄";
  }
};

export const formatName = key => {
  switch (key) {
    case "accountBank":
      return "开户行";
    case "adCity":
      return "地址（市）";
    case "adDetail":
      return "详细地址";
    case "adProvince":
      return "地址（省）";
    case "amount":
      return "发票金额";
    case "bankCard":
      return "银行名称";
    case "content":
      return "发票内容";
    case "createTime":
      return "发票创建时间";
    case "enterpriseAd":
      return "企业注册地址";
    case "enterpriseTel":
      return "企业注册电话";
    case "expressNo":
      return "快递号";
    case "invoiceTitle":
      return "发票抬头";
    case "invoiceType":
      return "发票类型";
    case "invoiceWay":
      return "开票方式";
    case "phoneNo":
      return "手机号";
    case "email":
      return "邮箱";
    case "postCode":
      return "邮编";
    case "receiver":
      return "收件人";
    case "status":
      return "发票邮寄状态";
    case "tax":
      return "税号";
    case "invoiceId":
      return "发票Id";
    case "id":
      return "注册号";
    default:
      return "其他";
  }
};

/**
 * 格式化域名Boolean类型转化为Number类型
 * @param {status} eg: true
 */
export function formatBooleanToNumber(status) {
  if (status) {
    return 1;
  } else {
    return 0;
  }
}

/**
 * 格式化域名Boolean类型转化为Number类型
 * @param {status} eg: true
 */
export function formatNumberToBoolean(status) {
  if (status) {
    return true;
  } else {
    return false;
  }
}

/**
 * 格式化时间
 * @param {Date} time
 * @param {*} format eg: YYYY-MM-DD HH:mm:ss
 */
export function formatTime(time, format = "YYYY-MM-DD HH:mm:ss") {
  if (!isDate(time)) {
    // REVIEW 假定传入数据不是Date就是时间戳
    time = new Date(time);
  }

  const year = time.getFullYear();
  const month = ("00" + (time.getMonth() + 1)).slice(-2);
  const day = ("00" + time.getDate()).slice(-2);
  const hour = ("00" + time.getHours()).slice(-2);
  const min = ("00" + time.getMinutes()).slice(-2);
  const sec = ("00" + time.getSeconds()).slice(-2);
  return format
    .replace("YYYY", year)
    .replace("MM", month)
    .replace("DD", day)
    .replace("HH", hour)
    .replace("mm", min)
    .replace("ss", sec);
}
export function isDate(time) {
  return time instanceof Date;
}
